// Story 6.9 (ADO-1163, AC4) — Status Badge (NEW primitive). Admin Users table.
// a11y: the tone is conveyed by the visible label text, not colour alone.

import type { ReactNode } from 'react';
import styles from './StatusBadge.module.css';

// Story 9.4 (ADO-1948) added `info` and `violet` for the order-history status
// chips: nine order states need more than four tones to stay distinguishable, and
// the Figma "Previous orders" frame draws Invoiced in lavender. Both new tones are
// AA-guarded in tokens.contrast.spec.ts.
export type StatusTone = 'success' | 'warning' | 'error' | 'neutral' | 'info' | 'violet';

export interface StatusBadgeProps {
  tone?: StatusTone;
  /** Show the leading status dot. */
  dot?: boolean;
  children: ReactNode;
}

export function StatusBadge({ tone = 'neutral', dot = true, children }: StatusBadgeProps) {
  return (
    <span className={`${styles.badge} ${styles[tone]}`}>
      {dot ? <span className={styles.dot} aria-hidden /> : null}
      {children}
    </span>
  );
}
